import * as React from "react";
import { connect } from "react-redux";

import SupportType from "../../screens/Settings/SupportType";
import {
  supportTypelist,
  AddSupportType,
  EditSupportType,
  DeleteSupportType,
  supportTypeSlectedPage
} from "./action";
class SupportTypeContainer extends React.Component<Props, State> {
  render() {
    return (
      <SupportType
        supportTypelist={this.props.supportTypelist}
        supportTypeList={this.props.supportTypeList}
        supportTypeCount={this.props.supportTypeCount}
        AddSupportType={this.props.AddSupportType}
        EditSupportType={this.props.EditSupportType}
        DeleteSupportType={this.props.DeleteSupportType}
        supportTypeSlectedPage={this.props.supportTypeSlectedPage}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    supportTypelist: () => {
      dispatch(supportTypelist());
    },
    AddSupportType: value => {
      // console.log(value);
      dispatch(AddSupportType(value));
    },
    EditSupportType: value => {
      // console.log(value);
      dispatch(EditSupportType(value));
    },
    DeleteSupportType: value => {
      dispatch(DeleteSupportType(value));
    },
    supportTypeSlectedPage: value => {
      dispatch(supportTypeSlectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    supportTypeList: state.SupportTypeReducer.supportTypeList,
    supportTypeCount: state.SupportTypeReducer.supportTypeCount
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(SupportTypeContainer);
